import { render, staticRenderFns } from "./FundingProjectsFinanceShow.vue?vue&type=template&id=36444547&scoped=true&"
import script from "./FundingProjectsFinanceShow.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsFinanceShow.vue?vue&type=script&lang=js&"
import style0 from "./FundingProjectsFinanceShow.vue?vue&type=style&index=0&id=36444547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36444547",
  null
  
)

export default component.exports